import React, { Component } from 'react';
import { mixin, RefluxMixin } from '../../Util';
import CourseActions from '../../actions/Course';
import { List, ListItem } from 'material-ui';
import { ContentSend } from 'components/Material/SvgIcons';
import { translate as _l } from 'oxygen-i18n';

const css = oxygenCss({
  noteLinkWrapper: {
    display: 'flex'
  },
  notesLink: {
    padding: '5px 0 0 5px',
    fontStyle: 'Italic',
    fontSize: '12px',
    flex: 1,
    ':nth-child(2)': {
      textAlign: 'right',
      marginRight: 5
    }
  },
  note: {
    background: '#ffc',
    padding: 5,
    display: 'inline-block'
  }
});

addTranslations({
  ['en-US']: {
    'No notes': 'No notes found',
    Notes: 'Notes'
  },
  ['sv-SE']: {
    'No notes': 'Inga noteringar funna',
    Notes: 'Anteckningar'
  }
});

class NotesOverview extends mixin(RefluxMixin, Component) {
  goToPage = pageId => {
    CourseActions.toggleNotes();
    this.props.ownerSlug && this.props.router.push(
      `/course/${this.props.ownerSlug}/${this.props.courseSlug}/${pageId}`
    );
  };

  render() {
    const { notes, course } = this.props;
    const notesList = (notes &&
      !!notes.length &&
      notes.map(section => {
        let sectionName = section.name;
        return section.pages.map(page => {
          let pageName = page.name;
          let pageId = page.id;
          return page.notes.map((notes, i) => {
            return (
              <ListItem
                rightIcon={<ContentSend />}
                key={notes.ts}
                onClick={() => this.goToPage(pageId)}
              >
                <div className={css.note}>{notes.body}</div>
                <div className={css.noteLinkWrapper}>
                  <div className={css.notesLink}>
                    {sectionName} - {pageName}
                  </div>
                  <div className={css.notesLink}>{notes.ts}</div>
                </div>
              </ListItem>
            );
          });
        });
      })) || <h2>{_l`No notes`}</h2>;

    return (
      <div>
        <h2>
          {course.name}
        </h2>
        <List style={{ background: '#fff' }}>{notesList}</List>
      </div>
    );
  }
}

export default NotesOverview;



// WEBPACK FOOTER //
// ./src/js/components/Notes/NotesOverview.js